module.exports = __webpack_public_path__ + "06_long_brown.60b77738.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/06_long_brown.png
// module id = oo01
// module chunks = 0